<div class="dialog-wrapper">
  <button class="close-btn" type="button" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>

  <h2 class="dialog-title">{{ 'fee.edit_personal_information' | translate }}</h2>

  <form [formGroup]="form" class="dialog-form">
    <mat-form-field appearance="fill" class="full-width field-half">
      <mat-label>{{ 'fee.user_name' | translate }}</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width field-half">
      <mat-label>{{ ('fee.date_of_birth' | translate) + ' (Optional)' }}</mat-label>
      <input matInput [matDatepicker]="dobPicker" formControlName="dateOfBirth" [placeholder]="('fee.date_of_birth' | translate) + ' (Optional)'" readonly>
      <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
      <mat-datepicker #dobPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width field-half">
      <mat-label>{{ 'fee.frequency' | translate }}</mat-label>
      <mat-select formControlName="frequency">
        @for (opt of frequencyOptions; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.labelKey | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width field-half">
      <mat-label>{{ 'fee.member_id' | translate }}</mat-label>
      <input matInput [value]="data.memberId" readonly>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width field-full">
      <mat-label>{{ 'fee.passport_or_id_card' | translate }}</mat-label>
      <input matInput formControlName="passportId">
    </mat-form-field>

    <div class="phone-field field-half">
      <label class="phone-field-label">{{ 'fee.phone' | translate }} *</label>
      <div class="phone-field-control" (click)="focusPhoneInput()">
        <input type="tel"
               #phoneInput
               formControlName="phone"
               class="form-control form-control-lg confirm-password-reduced-placeholder-width form-tel"
               placeholder="77 123456"
               (keyup)="preventDefaultIfNotNumber($event)"
               (keydown)="preventDefaultIfNotNumber($event)"
               (input)="onPhoneInput()"
               (blur)="validatePhoneNumber()"
               [ngClass]="{'has-error': isPhoneVisuallyInvalid || invalidPhoneMessage}"/>
      </div>
      @if (showPhoneValidation) {
        <div class="validation">
          <small>{{ (invalidPhoneMessage ?? '') | translate }}</small>
        </div>
      }
    </div>

    <div class="email-field field-half">
      <label class="email-field-label">{{ 'fee.email' | translate }} *</label>
      <div class="email-field-control">
        <input type="email"
               formControlName="email"
               class="form-control form-control-lg confirm-password-reduced-placeholder-width"
               [ngClass]="{'has-error': form.get('email')!.invalid && (form.get('email')!.touched || saveAttempted)}"/>
      </div>
      @if (form.get('email')!.hasError('required') && (form.get('email')!.touched || saveAttempted)) {
        <div class="validation">
          <small>{{ 'fee.validation.email_required' | translate }}</small>
        </div>
      }
      @if (form.get('email')!.hasError('email') && (form.get('email')!.touched || saveAttempted)) {
        <div class="validation">
          <small>{{ 'fee.validation.invalid_email' | translate }}</small>
        </div>
      }
    </div>

    @if (showDiscountSection) {
      <div class="discount-section field-full">
        <h3 class="section-title">{{ 'fee.edit_discount' | translate }}</h3>

        <div class="discount-grid">
          <mat-form-field appearance="fill" class="full-width discount-type-field">
            <mat-label>{{ 'fee.subgroups.discount_type' | translate }}</mat-label>
            <mat-select formControlName="discountType" (openedChange)="onDiscountSelectOpened($event)">
              @for (type of discountTypes; track type) {
                <mat-option [value]="type" (click)="onDiscountTypeOptionClick(type)">
                  {{ 'fee.subgroups.discount_types.' + type | translate }}
                </mat-option>
              }
            </mat-select>
            @if (form.get('discountType')!.hasError('discountTypeRequired')) {
              <mat-error>{{ 'fee.validation.discount_type_required' | translate }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'fee.discount' | translate }}</mat-label>
            <input matInput type="number" formControlName="discountValue" min="0" class="no-spinner"
                   inputmode="numeric" (keydown)="onDiscountKeyDown($event)" (paste)="onDiscountPaste($event)" />
            @if (form.get('discountValue')!.hasError('notInteger')) {
              <mat-error>{{ 'fee.validation.discount_whole_number' | translate }}</mat-error>
            }
            @if (form.get('discountValue')!.hasError('maxPercent')) {
              <mat-error>{{ 'fee.validation.discount_percent_max' | translate }}</mat-error>
            }
            @if (form.get('discountValue')!.hasError('exceedsPrice')) {
              <mat-error>{{ 'fee.validation.discount_less_than_price' | translate }}</mat-error>
            }
          </mat-form-field>

          <div class="price-summary">
            <span class="price-label">{{ 'fee.price' | translate }} - {{ basePrice | number:'1.0-0' }} ֏</span>
            <span class="final-price-label">{{ 'fee.final_price' | translate }} - {{ finalPrice | number:'1.0-0' }} ֏</span>
          </div>
        </div>

        <mat-form-field appearance="fill" class="full-width discount-reason-field">
          <mat-label>{{ 'fee.discount_reason' | translate }}</mat-label>
          <input matInput formControlName="discountReason" maxlength="30"
                 (keydown)="onReasonKeyDown($event)" (paste)="onReasonPaste($event)" />
          <mat-hint align="end">{{ form.get('discountReason')!.value?.length || 0 }}/30</mat-hint>
          @if (form.get('discountReason')!.hasError('maxlength')) {
            <mat-error>{{ 'fee.validation.max_30_characters' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>
    }
  </form>

  <div class="dialog-actions">
    <button type="button" class="btn-cancel" (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn-save" [disabled]="isSaveDisabled" (click)="save()">
      @if (saving) {
        <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
      } @else {
        {{ 'user_card.save' | translate }}
      }
    </button>
  </div>
</div>
